/**
 * This object can be used to determined whether the
 * user is seeing the page in a large, small or medium size screen
 */
export var smallBreakpoint = 768;
export var mediumBreakpoint = 1024;
export var smallBreakpointQuery = "(max-width: 767px)";
export var mediumBreakpointQuery = "(min-width: 768px) and (max-width:1023px)";
export var largeBreakpointQuery = "(min-width: 1024px)";
export var isSmall = function () { return window.matchMedia(smallBreakpointQuery).matches; };
export var isMedium = function () { return window.matchMedia(mediumBreakpointQuery).matches; };
export var isLarge = function () { return window.matchMedia(largeBreakpointQuery).matches; };
